import { render, staticRenderFns } from "./StitchTagsEditor.vue?vue&type=template&id=649b57c0&scoped=true&"
import script from "./StitchTagsEditor.vue?vue&type=script&lang=js&"
export * from "./StitchTagsEditor.vue?vue&type=script&lang=js&"
import style0 from "./StitchTagsEditor.vue?vue&type=style&index=0&id=649b57c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b57c0",
  null
  
)

export default component.exports